/* globals google */

let map = null
  , marker = null;

export default {
	init: function(){
		let $mapEle = $('#landing-map');

		if(!$mapEle.length){
			return false;
		}

		if(typeof $mapEle.data('lat') !== 'undefined' || typeof $mapEle.data('lng') !== 'undefined'){

			map = new google.maps.Map(document.getElementById('landing-map'), {
				center: { lat: parseFloat($mapEle.data('lat')), lng: parseFloat($mapEle.data('lng')) },
				zoom: 15,
      			disableDefaultUI: true
			});

			if($(window).outerWidth() > 600 ){
				marker = new google.maps.Marker({
					position: { lat: parseFloat($mapEle.data('lat')), lng: parseFloat($mapEle.data('lng')) },
					map: map,
					icon: {
						url :        '/wp-content/themes/class/dist/images/map-marker.png',
						size :       new google.maps.Size(190, 262),
						scaledSize : new google.maps.Size(95, 131),
						origin :     new google.maps.Point(0, 0),
						anchor:      new google.maps.Point(47, 131)
					}
				});

				map.setCenter({ lat: (parseFloat($mapEle.data('lat')) + 0.001), lng: (parseFloat($mapEle.data('lng')) - 0.01) })
			}
		}
	}
}